export const UPLOAD_ABORT_MESSAGE =
  "The upload took too long and was cancelled. Large videos can take several minutes. Please try again."

const FLOOR_MS = 3 * 60 * 1000
const CAP_MS = 45 * 60 * 1000
// 1 megabit/s. Slow enough that a video still uploading is not treated as stuck.
const SLOW_BYTES_PER_SECOND = 125_000

export function resourceUploadTimeoutMs(sizeBytes = 0) {
  const size = Number.isFinite(sizeBytes) && sizeBytes > 0 ? sizeBytes : 0
  const estimatedMs = Math.ceil(size / SLOW_BYTES_PER_SECOND) * 1000 + FLOOR_MS
  return Math.min(Math.max(estimatedMs, FLOOR_MS), CAP_MS)
}

export function uploadAbortReason() {
  return new DOMException(UPLOAD_ABORT_MESSAGE, "TimeoutError")
}

export function createTimedAbortSignal(ms, { AbortControllerImpl = AbortController } = {}) {
  const controller = new AbortControllerImpl()
  const timer = setTimeout(() => {
    controller.abort(uploadAbortReason())
  }, ms)
  return {
    signal: controller.signal,
    clear: () => clearTimeout(timer),
  }
}
